/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createTestAccount} from '../api'

export const useMutationCreateTestAccount = createReactQueryMutationHook('createTestAccount', createTestAccount)
